import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import App from './App';
import LoginWB from './pages/LoginWB';

/**
 * Top-level router that separates WB login from the main app.
 * This prevents WB login from triggering useEffects in App.js with expired tokens.
 */
function AppRouter() {
  return (
    <Switch>
      {/* WB login route - completely isolated from main app */}
      <Route path="/wb/login/:accountId" exact component={LoginWB} />

      {/* All other routes go through the main App */}
      <Route path="*" component={App} />
    </Switch>
  );
}

export default AppRouter;
